export const UNSUBSCRIBE_POLL_ITEMS = [
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.1',
    value: 'item-1',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.2',
    value: 'item-2',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.3',
    value: 'item-3',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.4',
    value: 'item-4',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.5',
    value: 'item-5',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.6',
    value: 'item-6',
  },
];

export const CLOSE_ACCOUNT_POLL_ITEMS = [
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.1',
    value: 'item-1',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.2',
    value: 'item-2',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.3',
    value: 'item-3',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.4',
    value: 'item-4',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.5',
    value: 'item-5',
  },
  {
    label: 'USER_PROFILE.CLOSE_ACCOUNT.POLL.ITEM.6',
    value: 'item-6',
  },
];
